import React from 'react';
import { Helmet } from 'react-helmet-async';

/* HaleHead — sets the Hale white-label browser-tab identity (favicon + title)
 * on every Hale surface. Overrides the default ToxIntel/Aᴳ favicon from
 * index.html at runtime so the Hale deployment (and all /hale/* routes) show
 * the Hale mark and a Hale title. */

export default function HaleHead({ title = 'The Hale League', description }) {
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {/* Hale favicon — SVG (modern), PNG + ICO fallbacks, apple-touch. */}
      <link rel="icon" type="image/svg+xml" href="/hale-favicon.svg" />
      <link rel="icon" type="image/png" sizes="512x512" href="/hale-icon-512.png" />
      <link rel="icon" type="image/png" sizes="192x192" href="/hale-icon-192.png" />
      <link rel="shortcut icon" href="/hale-favicon.ico" />
      <link rel="apple-touch-icon" href="/hale-apple-touch-icon.png" />
      <meta name="theme-color" content="#E63946" />
      <meta property="og:title" content={title} />
    </Helmet>
  );
}
